/* ============
 * Transaction Transformer
 * ============
 *
 * The transformer for the transaction data.
 */

import Transformer from './Transformer'

const moment = require('moment')

export default class TransactionTransformer extends Transformer {
  /**
   * Method used to transform a fetched transaction.
   *
   * @param transaction The fetched transaction.
   *
   * @returns {Object} The transformed transaction.
   */
  static fetch (transaction) {
    return {
      captureTrxUid: transaction['capture_trx_uid'],
      trxDate: moment(transaction['trx_date']).format('YYYY-MM-DD HH:mm'),
      offerId: transaction['deal_id'],
      offerName: transaction['deal_title'],
      locationId: transaction['location_id'],
      locationName: transaction['merchantLocation']
        ? transaction['merchantLocation']['merchant_location_name']
        : null,
      ccUID: transaction['cc_uid'],
      totalAmount: transaction['amount'],
      status: transaction['status'],
      cashbackAmount: transaction['cashback_amount'],
      transactionSequenceNumber: transaction['transaction_sequence_number'],
      ccNumber: transaction['cc_first_last'],
      amount: transaction['amount'],
      cashbackPercentage: transaction['cashback_percentage']
    }
  }

  /**
   * Fetch data to display in datatable
   * @param data
   */
  static dtFetch (data) {
    const fieldDefinitions = [
      {
        field: 'dealId',
        idx: 0,
        propertyPath: 'dealId'
      },
      {
        field: 'offerName',
        idx: 1,
        propertyPath: 'deal.title'
      },
      {
        field: 'transactionSequenceNumber',
        idx: 2,
        propertyPath: 'transactionSequenceNumber'
      },
      {
        field: 'trxDate',
        idx: 3,
        propertyPath: 'trxDate',
        transform (v) {
          return moment.unix(v).format('YYYY-MM-DD')
        }
      },
      {
        field: 'time',
        idx: 4,
        propertyPath: 'trxDate',
        transform (v) {
          return moment.unix(v).format('HH:mm')
        }
      },
      {
        field: 'firstClaim',
        idx: 5,
        propertyPath: 'firstClaim',
        transform (v) {
          return moment.unix(v).format('YYYY-MM-DD')
        }
      },
      {
        field: 'ccNumber',
        idx: 6,
        propertyPath: 'ccFirstLast'
      },
      {
        field: 'amount',
        idx: 7,
        propertyPath: 'amount'
      },
      {
        field: 'tipPercentage',
        idx: 8,
        propertyPath: 'tipPercentage'
      },
      {
        field: 'amountBeforeTip',
        idx: 9,
        propertyPath: 'amountBeforeTip'
      },
      {
        field: 'cashbackPercentage',
        idx: 10,
        propertyPath: 'cashbackPercentage'
      },
      {
        field: 'cashbackAmount',
        idx: 11,
        propertyPath: 'cashbackAmount'
      },
      {
        field: 'cashbackAmountBeforeTax',
        idx: 12,
        propertyPath: 'cashbackAmountBeforeTax'
      },
      {
        field: 'provincialTaxCashbackAmount',
        idx: 13,
        propertyPath: 'provincialTaxCashbackAmount'
      },
      {
        field: 'federalTaxCashbackAmount',
        idx: 14,
        propertyPath: 'federalTaxCashbackAmount'
      },
      {
        field: 'combinedTaxRate',
        idx: 15,
        propertyPath: 'combinedTaxRate'
      },
      {
        field: 'estimatedAmountBeforeTipAndTaxes',
        idx: 16,
        propertyPath: 'estimatedAmountBeforeTipAndTaxes'
      },
      {
        field: 'marketingFee',
        idx: 17,
        propertyPath: 'marketingFee'
      },
      {
        field: 'marketingFeeAmount',
        idx: 18,
        propertyPath: 'marketingFeeAmount'
      },
      {
        field: 'provincialTaxMarketingFeeAmount',
        idx: 19,
        propertyPath: 'provincialTaxMarketingFeeAmount'
      },
      {
        field: 'federalTaxMarketingFeeAmount',
        idx: 20,
        propertyPath: 'federalTaxMarketingFeeAmount'
      },
      {
        field: 'totalMarketingFeeInclTax',
        idx: 21,
        propertyPath: 'totalMarketingFeeInclTax'
      },
      // {
      //   field: 'invoiceId',
      //   idx: 21,
      //   propertyPath: 'invoiceID'
      // },
      {
        field: 'invoiceNumber',
        idx: 22,
        propertyPath: 'invoiceNumber',
        transform (v, record) {
          if (!v) return ''
          return `<a data-invoiceid="${record.invoiceID}" data-invoiceNumber="${record.invoiceNumber}" href="javascript:;">${v}</a>`
        }
      },
      {
        field: 'status',
        idx: 23,
        propertyPath: 'status'
      }
    ]

    return data.map(record => {
      return fieldDefinitions.reduce((acc, field) => {
        const transform = field['transform'] || ((v) => v)

        let val = ''

        try {
          val = transform(TransactionTransformer.accessProperty(record, field['propertyPath']), record)
        } catch (err) {
          console.error(err)
        }
        acc.splice(field['idx'], 0, val)
        return acc
      }, [])
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/TransactionTransformer.js